import React, { useContext } from 'react';
import { Redirect, Route } from 'react-router-dom';

import { UserContext } from '../context/UserContext';

const PesquisaRoute = props => {
  const { isPesquisa } = useContext(UserContext);

  if (isPesquisa) {
    return <Route {...props} />;
  } else if (!isPesquisa) {
    return <Redirect to='/login' />;
  } else {
    return null;
  }
};

export default PesquisaRoute;
